import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import * as _ from 'lodash';
import {ConnectionFilterService} from '../../../../../network/utils/filters/connection/connection-filter.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectionApiService {
  constructor(private http: HttpClient) {}

  readonly connectionUrl: string = 'topology/connection';

  public getConnectionsForMap(params: any = {}): Promise<any> {
    return this.http.get(this.connectionUrl)
      .pipe(
        map((connections: any) => {
          connections.elements = this.filterConnections(connections.elements, params);

          return connections;
        })
      ).toPromise();
  }

  public getConnectionsForMapNew(params: any = {}, allConnections): any {
    const localConnections = _.clone(allConnections);

    allConnections.elements = this.filterConnections(allConnections.elements, params);
    return allConnections;
  }

  public getConnections(params: any = {}): Promise<any> {
    params = UrlQueryService.restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(this.connectionUrl, params);

    return this.http.get(url).toPromise();
  }

  public getConnection(id: number): Promise<any> {
    return this.http.get(`${this.connectionUrl}/${id}`).toPromise();
  }

  public editConnection(connection: any, id: number): Promise<any> {
    const url = `${this.connectionUrl}/${id}`;
    return this.http.put(url, connection).toPromise();
  }

  public addConnection(connection: any): Promise<any> {
    return this.http.post(this.connectionUrl, connection).toPromise();
  }

  public deleteConnection(id: number): Promise<any> {
    const url = `${this.connectionUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  public deleteConnections(ids): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.connectionUrl, {filter: {id: {value: ids, operator: '='}}});
    return this.http.delete(url).toPromise();
  }

  private filterConnections(connections, params): any {
    return (params && params.mapFilter) ?
      ConnectionFilterService.mapFilter(connections, params.searchObject) : connections;
  }
}
